<template>
  <el-menu
    v-if="currency !== 'USD'"
    class="lad-navigation--menu--exchange-rate"
  >
    <el-menu-item>
      <p class="value"
        >{{ $t(`${base}.exchange_rate`) }}:
        {{ currentRate | ladFnCurrency(currency) }} {{ currency }}</p
      >
      <p class="date">{{ $dayjs() | ladFnStrDate('MMM DD · YYYY') }}</p>
    </el-menu-item>
  </el-menu>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LadExchangeRateMenu',
  data() {
    return {
      base: 'navbar',
    }
  },
  computed: {
    ...mapState('settings', ['currency', 'exchange_rate']),
    currentRate() {
      const exchange = this.exchange_rate.find((t) => t.code === this.currency)
      const value = exchange ? exchange.rate : 0

      return this.$options.filters.ladFnPrecision(value, 2)
    },
  },
}
</script>

<style lang="scss">
.lad-navigation--menu--exchange-rate {
  display: none;
  padding: 0 5px;
  align-self: center;
  border: unset;

  // Large devices (desktops, 992px and up)
  @media (min-width: 992px) {
    display: block;
    padding: 0 5px 0 20px;
  }

  .el-menu-item {
    display: grid;
    height: unset;
    gap: 4px;

    &:hover,
    &:focus {
      background-color: unset;
    }
  }

  .title,
  .value,
  .date {
    margin: 0;
    text-align: right;
  }

  .title,
  .date {
    font-weight: 400;
    font-size: 12px;
    line-height: 1;
  }

  .value {
    font-weight: 700;
    font-size: 16px;
    line-height: 1;
  }
}
</style>
